import axios from 'axios'

export default axios.create({
  baseURL: 'https://api.revenuecat.com',
  headers: {
    authorization: 'Bearer PvtQPseruJJiCofUOMZIjJRelkoyAIOI',
  },
})
